import {useState} from "react";
import {FormattedMessage} from "react-intl";
import Card from "@/components/Card";

type Props = {
    token: string;
};

/** Creates an audio player for a media.
 *
 * @param token - The media download token to play the specific media
 * */
const MediaPlayer = ({token}: Props) => {
    const [error, setError] = useState(false);

    return (
        <div style={{minWidth: 400}}>
            {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
            <audio
                style={{width: "100%"}}
                key={token}
                controls
                preload="metadata"
                src={token ? `/api/media/${token}` : undefined}
                onError={(_) => setError(true)}
            />
            {error && (
                <Card variant="error" sx={{marginTop: 2}}>
                    <FormattedMessage
                        id="media_player.playback_error"
                        defaultMessage="There was an error playing this media. Please reload the page and try again."
                    />
                </Card>
            )}
        </div>
    );
};

export default MediaPlayer;
